import { render, staticRenderFns } from "./TemaFormulario.vue?vue&type=template&id=7e8f1aa6&scoped=true&"
import script from "./TemaFormulario.vue?vue&type=script&lang=js&"
export * from "./TemaFormulario.vue?vue&type=script&lang=js&"
import style0 from "./TemaFormulario.vue?vue&type=style&index=0&id=7e8f1aa6&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e8f1aa6",
  null
  
)

export default component.exports